import "core-js/modules/es6.object.assign";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { renderFormMixins } from '@/mixins/renderFormMixins';
export default {
  name: "addMenuSon",
  mixins: [renderFormMixins],
  data: function data() {
    return {
      personMenuData: [],
      states: [{
        value: 0,
        label: "禁用"
      }, {
        value: 1,
        label: "启用"
      }],
      formModel: {
        parent_code: 0,
        menu_name: null,
        route: null,
        menu_desc: null,
        sort_order: null
      },
      formRules: {
        menu_name: [{
          required: true,
          message: '请输入菜单名称',
          trigger: 'blur'
        }],
        route: [{
          required: true,
          message: '请输入路径',
          trigger: 'blur'
        }],
        menu_desc: [{
          required: true,
          message: '请输入菜单说明',
          trigger: 'change'
        }]
      }
    };
  },
  props: {
    _vm: {},
    edit: {},
    setData: {},
    personMenu: {}
  },
  components: {},
  computed: {},
  methods: {},
  mounted: function mounted() {},
  created: function created() {
    if (this.edit) {
      Object.assign(this.formModel, this.setData);
      this.$set(this.formModel, "menu_name", this.setData.menu_name);
      this.$set(this.formModel, "route", this.setData.route);
      this.$set(this.formModel, "menu_desc", this.setData.menu_desc);
      this.$set(this.formModel, "sort_order", this.setData.sort_order);
    }

    if (this.personMenu) {
      this.personMenuData.push(this.personMenu);
      this.$set(this.formModel, "parent_code", this.personMenu.parent_code);
    }
  }
};